export const serializeDetailItem = ({ type, id, tab })=>
  `${type}-${id}-${tab}`;

export const deserializeDetailItem = (detailItem)=> {
  const [type, id, tab] = detailItem.split('-');
  return { type, id: parseInt(id), tab };
};
